import { get } from 'lodash';
import { activeFilters } from 'utils/filters';
import { mergeIfPresent } from '../helpers';
import REST from '../rest';

const ENDPOINT = (reportId) => `api/v1/reports/${reportId}/widgets`;

const dataTypeQueryParams = {
  single_choice: { aggregations: 'sum' },
  multiple_choice: { aggregations: 'sum' },
  html: { aggregations: 'avg' },
  rating: { aggregations: 'count', group_by: 'answers.data.name' },
  net_promoter_score: { aggregations: 'count', group_by: 'answers.data.name' },
};

const groupByParams = (groupBy) => {
  if (get(groupBy, 'canonical') === null) {
    return {};
  }
  return { _literal: { group_by: get(groupBy, 'canonical') || '' } };
};

const queryParams = (widgetType, groupBy, filters = null) => {
  const params = { ...dataTypeQueryParams[widgetType], ...groupByParams(groupBy) };
  const queryFilters = filters || activeFilters();
  return mergeIfPresent(params, queryFilters, (filter) => ({ filter }));
};

export const list = (reportId) => REST.get(ENDPOINT(reportId));

export const load = (reportId, widget, groupBy = null) => (
  REST.getAction(ENDPOINT(reportId), widget.id, 'data', queryParams(widget.type, groupBy))
);

export const loadPreview = (reportId, widget, groupBy = null, filters = null) => (
  REST.getAction(ENDPOINT(reportId), widget.id, 'preview', queryParams(widget.type, groupBy, filters))
);

export const create = (reportId, data) => REST.post(ENDPOINT(reportId), data);

export const update = (reportId, widgetId, data) => REST.patch(ENDPOINT(reportId), widgetId, data);

export const deleteWidget = (reportId, id) => (
  REST.delete(ENDPOINT(reportId), id)
);
